import { LayoutModule } from '../../../../layout/modules';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useAlertsDetail } from './hook';
import { AlertsRegisterHistory } from './registerHistory';
import { AlertsProcess } from './process';
import { AlertsStatus } from './alertStatus';
import { AlertsSection } from './alert';
import { AlertsNotifications } from './notifications';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    ALERTS,
    ALERTS_DETAIL,
    ALERTS_EDIT,
} from '../../../../../routes/paths';

import { AlertHistorical } from '../historical';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const AlertsDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { alert, loading, alertHistorical } = useAlertsDetail();

    const [showHistorical, setShowHistorical] = useState(false);

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = alert && alert?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle caso reglas alertas"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={alert?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: ALERTS,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: ALERTS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: ALERTS_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <AlertHistorical
                            historical={alertHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <AlertsProcess alert={alert} loading={loading} />
                </LayoutModule>
            </LayoutModule>
            <AlertsStatus alertStatus={alert?.alertStatus} loading={loading} />
            <AlertsSection
                alertSection={alert?.alertSection}
                loading={loading}
            />
            <AlertsNotifications alert={alert} loading={loading} />
            <AlertsRegisterHistory alert={alert} />
        </>
    );
};
